import * as React from "react";
import { PatientCardSummaryAction } from "./patientCardCommonUi";
import { ReactComponent as CopyIcon } from "./../assets/copyIcon.svg";
import clsx from "clsx";
import { Tooltip } from "@mui/material";
import { CSSCollapseTransitionComponent } from "./layout/CSSCollapseTransitionComponent";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ActionIconProps {
  className?: string;
  noBackground?: boolean;
  onClick: (e) => void;
  icon?: React.ReactNode;
  title?: string;
  inExtension?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SummaryActionIcon = ({ ...props }: ActionIconProps) => (
  <Tooltip
    title={props.title || "Copy"}
    TransitionComponent={
      props.inExtension ? CSSCollapseTransitionComponent : undefined
    }
  >
    <PatientCardSummaryAction
      className={clsx(props.className, props.noBackground ? "icon-only" : "")}
      onClick={props.onClick}
    >
      {!props.icon ? <CopyIcon /> : props.icon}
    </PatientCardSummaryAction>
  </Tooltip>
);
